export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="shrink-0">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-film-line text-3xl md:text-4xl text-background-50"></i>
              </div>
            </div>
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-3">
                <i className="ri-information-line"></i>
                关于我们
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于香蕉动漫</h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                香蕉动漫诞生于对漫画的热爱，致力于打造全免费、无广告干扰的漫画在线阅读平台。我们收录了超过三万部优质漫画作品，涵盖韩漫、日漫、国漫、条漫等多种类型，支持下拉式流畅阅读。无论你是追求热血战斗的少年漫爱好者，还是偏爱甜蜜恋爱的少女漫读者，香蕉动漫都能满足你的阅读需求。平台每日同步更新热门连载，无需注册即可畅享全部内容。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}